export const en = {
  heading: "Experience",
  hint: "Open a role for the detail",
  roles: [
    {
      title: "Back-end Developer",
      company: "Rocketseat",
      dateRange: "February 2025 - July 2026",
      current: true,
      bullets: [
        "Backend systems: built production features and internal services with Node.js, TypeScript, PostgreSQL, Redis, QStash and Docker.",
        "AI engineering: designed and built a multi-agent workflow for code review, requirement validation, feedback generation and scoring.",
        "Platform quality: restructured a legacy automated test suite, defined testing standards and created a project-specific skill to guide future implementations.",
        "Operational tools: delivered internal dashboards and automations that reduced manual work and improved visibility into product metrics.",
      ],
    },
    {
      title: "Blockchain Developer",
      company: "BWS",
      dateRange: "October 2023 - September 2024",
      current: false,
      bullets: [
        "API architecture: built and maintained Nest.js APIs integrated with multiple blockchain networks.",
        "Domain modeling: applied DDD and other patterns to improve internal infrastructure, abstractions and API maintainability.",
        "Reliability: increased Jest test coverage and configured GitHub CI for API test pipelines.",
      ],
    },
    {
      title: "Full-Stack and Blockchain Engineer",
      company: "Freelance",
      dateRange: "June 2022 - October 2023",
      current: false,
      bullets: [
        "Product backend: delivered Nest.js and Fastify APIs from ideation to deployment for complete client products.",
        "Data layer: modeled SQL and NoSQL databases with Prisma and TypeORM.",
        "Deployment: provisioned cloud machines and served applications with NGINX on GCP and Digital Ocean.",
      ],
    },
    {
      title: "Back-End and Blockchain Engineer",
      company: "Softrends",
      dateRange: "June 2020 - June 2022",
      current: false,
      bullets: [
        "Backend ownership: evolved from first developer to owner of back-end, DevOps and blockchain responsibilities.",
        "API development: built REST APIs with Express.js, Adonis.js, Nest.js and other frameworks, covering auth, SMTP email, WebSocket, cache, blockchain, SQL/NoSQL databases and other integrations.",
        "Technical leadership: led a small back-end team through planning, technology choices, task division and delivery.",
        "Service quality: applied SOLID principles and other patterns, test suites, documentation and configured cloud infrastructure with NGINX for production services.",
      ],
    },
    {
      title: "Full-Stack Developer and Smart Contract QA",
      company: "Gravel Coin",
      dateRange: "December 2018 - December 2019",
      current: false,
      bullets: [
        "Backend foundation: built an Express.js and MySQL API for a token sale platform.",
        "Quality assurance: built a test suite and fixed Solidity smart contracts with Mocha.js, Chai.js, Jest and Truffle.",
      ],
    },
  ],
};
